import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { View, TouchableOpacity, Text, Animated, Pressable, } from "react-native";
import { useRef } from "react";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider.js";

export default function WebButton(props) {
    const fadeAnim = useRef(new Animated.Value(0)).current;
    const { globalSettings } = useContext(GlobalSettingsContext);
    const [colourTheme1, setColourTheme1] = React.useState("#230D94");

    // React.useEffect(() => {
    //     setColourTheme1(globalSettings.find(
    //         (a) => a && a.description.toLowerCase() === "colour theme 2"
    //     )?.value)
    // });

    function fadeAnimIn() {
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 200
        }).start();
    }

    function fadeAnimOut() {
        Animated.timing(fadeAnim, {
            toValue: 0,
            duration: 200
        }).start();
    }

    return (
         <Animated.View {...props}
            style={props.style ? props.style : {
                width: "auto",
                height: "48px",
                maxWidth: "426px",
                minWidth: "320px",
                lineHeight: "48px",
                borderRadius: "100px",
                backgroundColor: colourTheme1,
                elevation: 1,
                zIndex: 1,
            }}
        >
            <Pressable
                accessibilityRole="button"
                delayLongPress="750"
                onHoverIn={() => fadeAnimIn()}
                onHoverOut={() => fadeAnimOut()}
                onPress={props?.buttonOnPress ? props.buttonOnPress : null}
                style={(state) => [
                    {
                        alignSelf: 'stretch',
                        width: "100%",
                        zIndex: 10,
                        elevation: 10,
                    }
                ]}
            >
                <Animated.View
                    style={[
                        props.styleFade,
                        {
                            opacity: fadeAnim
                        },
                    ]}
                />
                <Text style={props.textStyle ? props.textStyle : {
                    lineHeight: "48px",
                    color: props.textColor ? props.textColor : "white",
                    alignItems: "center",
                    alignSelf: "center",
                    position: "absolute",
                    justifyContent: "center",
                    flex: 1,
                    textAlignVertical: 'center',
                    flexDirection: 'row',
                    fontSize: 15,
                    fontWeight: "bold",
                    textAlign: 'center',
                    textAlignVertical: 'center',
                    height: 48,
                    elevation: 5,
                    zIndex: 5,
                }}>{props.text}</Text>
            </Pressable>
        </Animated.View> );

};